import { render, staticRenderFns } from "./ObjetivosVideos.vue?vue&type=template&id=86c94710&scoped=true&"
import script from "./ObjetivosVideos.vue?vue&type=script&lang=js&"
export * from "./ObjetivosVideos.vue?vue&type=script&lang=js&"
import style0 from "./ObjetivosVideos.vue?vue&type=style&index=0&id=86c94710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c94710",
  null
  
)

export default component.exports